import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { PhaseOutput } from 'phase/model/phase.output';
import { PhaseApiPort } from 'phase/port/phase-api.port';
import { FetchOrganizationPhasesByUserIdApiQuery } from 'phase/query/fetch-organization-phases-by-user-id.query';
import { UserSessionPort } from 'user/port/user-session.port';

import { ApiAdapter } from '../../common/api.adpater';

@Injectable()
export class PhaseApiAdapter extends ApiAdapter implements PhaseApiPort {
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _fetchOrganizationPhasesByUserIdApiQuery: FetchOrganizationPhasesByUserIdApiQuery
	) {
		super(userSessionPort, translateService);
	}

	public fetchPhasesByUserId(userId: string): Promise<PhaseOutput[]> {
		return this.fetch(this._fetchOrganizationPhasesByUserIdApiQuery, {
			userId,
		});
	}
}
